import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { format, parseISO } from 'date-fns';

import DefaultPagination from 'components/DefaultPagination';

const renderDateOrDash = value =>
  value ? format(parseISO(value), 'dd MMM yyyy') : '-';

function ContactsTable({
  contacts,
  activePage,
  totalCount,
  pageSize,
  onContactSelected,
  onPageChange,
}) {
  const isDataAvailable = contacts.length !== 0;

  return (
    <>
      <Table celled selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Business name</Table.HeaderCell>
            <Table.HeaderCell>Registered email</Table.HeaderCell>
            <Table.HeaderCell>Type of business</Table.HeaderCell>
            <Table.HeaderCell>Submission status</Table.HeaderCell>
            <Table.HeaderCell>Submission date</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {isDataAvailable ? (
            contacts.map(contact => (
              <Table.Row
                key={contact.id}
                style={{ cursor: 'pointer' }}
                onClick={() => onContactSelected(contact.id)}
              >
                <Table.Cell>{contact.business_name || '-'}</Table.Cell>
                <Table.Cell>{contact.business_email || '-'}</Table.Cell>
                <Table.Cell>{contact.type_of_business || '-'}</Table.Cell>
                <Table.Cell>{contact.status || '-'}</Table.Cell>
                <Table.Cell>
                  {renderDateOrDash(contact.submission_date)}
                </Table.Cell>
              </Table.Row>
            ))
          ) : (
            <Table.Row>
              <Table.Cell colSpan="5" style={{ textAlign: 'center' }}>
                No data
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
      {isDataAvailable && (
        <DefaultPagination
          activePage={activePage}
          totalCount={totalCount}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
}

ContactsTable.propTypes = {
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      business_name: PropTypes.string,
      business_email: PropTypes.string,
      type_of_business: PropTypes.string,
      status: PropTypes.string,
      submission_date: PropTypes.string,
    })
  ).isRequired,
  activePage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onContactSelected: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default ContactsTable;
